/* eslint-disable camelcase */
import React from 'react';
import PropTypes from 'prop-types';

import { SvgIcon } from 'common/react/components/SvgIcon';

/**
 * Renders a CTA button based on supplied configuration.
 *
 * @param ctaConfig.ctaConfig
 * @param {object} ctaConfig The configuration for the CTA.
 * @param {string} matchTitle The match title, e.g. 'Sydney Swans v GWS GIANTS'.
 * @param ctaConfig.matchTitle
 * @returns {JSX.Element} The CTA button.
 */
export const TLCondensedCta = ({ ctaConfig, matchTitle }) => {
    const url = new URL(ctaConfig.ctaLink, location.origin);

    const onClick = () => {
        PULSE.app.tracking.recordEvent(
            PULSE.app.common.CONSTANTS.TRACKING.EVENTS.SELECT.CTA,
            {
                eventData: {
                    link_text: ctaConfig.ctaText,
                    link_url: ctaConfig.ctaLink,
                    outbound: url.origin !== location.origin,
                    type:
                        url.origin !== location.origin
                            ? 'external'
                            : 'internal',
                    component_name: `${matchTitle} (condensed team lineups)`,
                    component_content_type:
                        PULSE.app.common.CONSTANTS.TRACKING.CONTENT_TYPES
                            .LINEUPS,
                    component_type: `${matchTitle} (condensed team lineups)`
                }
            }
        );
    };

    return (
        <div className="team-lineups-condensed-embeddable__cta">
            <a
                href={ctaConfig.ctaLink}
                className="button button-new button-new--primary team-lineups-condensed-embeddable__cta-button"
                role="button"
                onClick={onClick}
                target={
                    ctaConfig.ctaDefaultPath === 'true'
                        ? '_blank'
                        : PULSE.app.common.url.isExternalUrl(ctaConfig.ctaLink)
                        ? '_blank'
                        : '_self'
                }
                rel="noreferrer"
            >
                <span>{ctaConfig.ctaText}</span>
                <SvgIcon icon="arrow-right" className="icon" />
            </a>
        </div>
    );
};

TLCondensedCta.propTypes = {
    ctaConfig: PropTypes.object.isRequired,
    matchTitle: PropTypes.string
};
